@if (title()) {
  <p class="benefits-list-title">{{ title() }}</p>
}

<ul class="benefits-list">
  @for (item of benefitsListItems(); track $index) {
    <li class="benefit-item">
      <ng-container
        [ngTemplateOutlet]="iconTemplate()"
        [ngTemplateOutletContext]="{
          iconName: item.iconName,
        }"
      />
      <span class="benefit-item__text">{{ item.text }}</span>
    </li>
  }
</ul>
